// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 177 ? "home" : chunkId) + "." + {"177":"bc26a363","533":"6900d7c4"}[chunkId] + ".chunk.js";
};